import React, { type FC, useCallback, useState } from 'react'

import { useIntl } from 'react-intl'

import {
  Flex,
  Group,
  InputText,
  Item,
  Panel,
  SearchForm,
} from 'mailup-web-components'

import { resetSearchCallback } from 'Pages/unifiedFiltersListPage/callbacks/search'
import InputCategories from 'Pages/unifiedFiltersListPage/components/InputCategories'
import InputFilterTypes from 'Pages/unifiedFiltersListPage/components/InputFilterTypes'
import { useAtom } from 'jotai'
import { useAtomCallback } from 'jotai/utils'
import { changeFiltersQueryAndSearch } from '../callbacks/filters'
import { filtersQueryAtom } from '../state/state'

const AdvancedSearch: FC = () => (
  <Flex flexDirection='column' gap='16px' margin='16px 0 0 0' flexGrow={1}>
    <InputFilterTypes />
    <InputCategories />
  </Flex>
)

const Search: FC = () => {
  const intl = useIntl()
  const [expanded, setExpanded] = useState(false)
  const [query, setQuery] = useAtom(filtersQueryAtom)
  const handleSearch = useAtomCallback(
    useCallback(async (get, set) => {
      await changeFiltersQueryAndSearch(get, set, { pageNumber: 1 })
    }, []),
  )
  const handleReset = useAtomCallback(resetSearchCallback)

  const handleToggleAdvanced = (): void => {
    setExpanded((prev) => !prev)
  }

  return (
    <Panel data-mu-test='search-panel' margin='0'>
      <SearchForm
        advanced
        expanded={expanded}
        onClickToggle={handleToggleAdvanced}
        onClickReset={handleReset}
        labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
        labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
        AdvancedSearchComponent={AdvancedSearch}
        onSubmit={handleSearch}
      >
        <Group>
          <Item>
            <InputText
              data-mu-test='input-name'
              name='name'
              placeholder={intl.formatMessage({
                id: 'Load.FiltersList.InputNamePlaceholder',
              })}
              value={query.search}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setQuery((q) => {
                  return { ...q, search: e.target.value }
                })
              }}
            />
          </Item>
        </Group>
      </SearchForm>
    </Panel>
  )
}

export default Search
